import { render, staticRenderFns } from "./ProjectsView.html?vue&type=template&id=b865b9a6&scoped=true&"
import script from "./ProjectsView.js?vue&type=script&lang=js&"
export * from "./ProjectsView.js?vue&type=script&lang=js&"
import style0 from "./ProjectsView.scss?vue&type=style&index=0&id=b865b9a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b865b9a6",
  null
  
)

component.options.__file = "ProjectsView.vue"
export default component.exports